import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PasswordConfirmComponent from '../../password-confirm-component';
import { impersonateUser } from '../../actions';

// Create an editable cell renderer
const ActionsCell = ({
  cell: { value: initialValue },
  dispatch
}) => {
  // We need to keep and update the state of the cell normally
  const [value, setValue] = React.useState(initialValue);
  const [modalOpen, setModalOpen] = React.useState(false);

  // If the initialValue is changed externall, sync it up with our state
  React.useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return <div className="d-flex">
    <Link to={`/profile/${value}`} title="View Profile"><button className="btn btn-secondary"><i className="fas fa-user"></i></button></Link>
    <button className="btn btn-secondary" onClick={() => setModalOpen(true)}><i className="fas fa-user-secret"></i></button>
    {
      modalOpen && (
        <PasswordConfirmComponent
          onSubmit={(formValues) => { dispatch(impersonateUser(formValues.password, value)); }}
          onClose={() => setModalOpen(false)}
          errType="IMPERSONATION"
      />)
      }
  </div>
}
export default connect()(ActionsCell);
